import React, { Component } from "react";
import { Row, Col, Card, Button, CardHeader, CardBody, UncontrolledAlert } from "reactstrap";
import { MdModeEdit, MdArrowBack } from "react-icons/md";
import { NavLink, Link } from "react-router-dom";
import { UserUploadContents, UserPublishedContents } from "../../../../_constants/RouteVariables";
import { publishService } from "./service/publishContents.service";
import TextEditor from "../../../Shared/Forms/TextEditor";
import Formsy from "formsy-react";
import { EditorState, ContentState, convertFromHTML } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";


class ViewSpecificContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            postId: null,
            postInterest: null,
            postTitle: null,
            postBody: null,
            imageUrl: null,
            interestId: null,
            data: null,
            postStatus: null,
            isEdit: false,
            error: null,
            declineComment: null,
            editorState: EditorState.createEmpty(),
            stripPastedStyles: false,
        };
    }

    viewValue = (data) => {
        const editorState = EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(data)));

        this.setState({ editorState });
    };

    componentDidMount() {
        if (this.props.location.state) {
            
            const { postId } = this.props.location.state;

             this.getPostsById(postId);
        } else {
            this.setState({ data: null, status: null });
        }
    }
    getPostsById = (id) => {
        this.setState({ submitting: true });
        publishService
            .getPost(id)
            .then((response) => {
                response &&
                    this.setState({
                        postId: id,
                        postInterest: response.interestName,
                        postTitle: response.title,
                        postBody: response.body,
                        interestId: response.interestId,
                        postStatus: response.status,
                        declineComment: response.reviewerRemarks,
                        imageUrl: response.imageUrl,
                        formError: null,
                        submitting: false,
                        submitSucessful: true,
                        error: null,
                        fetching: false,
                        isEdit: true,
                    });

                this.viewValue(this.state.postBody);
            })
            .catch((error) => this.setState({ error, fetching: false }));
    };

    stopEdit = () => {
        this.setState({
            isEdit: false,
        });
    };
    changeDeclineToDraft = (id) => {
        publishService
            .changePostStatus(id)
            .then((response) => {})
            .catch((error) => this.setState({ error, fetching: false }));
    };

    routeChange = () => {
        let path = `/userpublishedcontents`;
        this.props.history.push(path);
    };

    render() {
        const { postId, postTitle, postBody, isEdit, postStatus, error, declineComment, stripPastedStyles, postInterest, imageUrl } = this.state;

        return (
            <div>
                <NavLink to={UserPublishedContents}>
                    <Button type="button" color="primary" className="mb-2">
                        <MdArrowBack />
                        <span>Back</span>
                    </Button>
                </NavLink>
                {error ? <UncontrolledAlert color="danger">{error.message}</UncontrolledAlert> : null}
                <Row>
                    <Col sm="7">
                        <Card>
                            <Formsy>
                                <TextEditor name="body" 
                                value={null} 
                                isViewOnly={true} 
                                isEdit={isEdit} 
                                stopEdit={this.stopEdit}
                                 postBody={postBody} 
                                 toolbarHidden={true} 
                                 stripPastedStyles={stripPastedStyles} 
                                 postInterest={postInterest} 
                                 postTitle={postTitle} />
                            </Formsy>
                        </Card>
                    </Col>
                    <Col>
                        {postStatus === "DECLINED" ? (
                            <div>
                                <Card>
                                    <CardHeader>Decline Comment</CardHeader>
                                    <CardBody>
                                        <p>{declineComment}</p>
                                        <br />
                                        <Row>
                                            <Col sm="12 offset-4">
                                                <Link
                                                    to={{
                                                        pathname: UserUploadContents,
                                                        state: { postId: postId, change: "decline" },
                                                    }}
                                                    style={{ textDecoration: "none" }}
                                                >
                                                    <Button type="button" color="primary" size="lg">
                                                        <MdModeEdit />
                                                        <span>Edit Post</span>
                                                    </Button>
                                                </Link>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </div>
                        ) : null}
                        {imageUrl ? (
                            <div>
                                <Card
                                    style={{
                                        marginTop: "1rem",
                                        width: "auto",
                                        display: "inline-block",
                                    }}
                                >
                                    <CardBody>
                                        <img src={imageUrl} width="200" alt="" />
                                    </CardBody>
                                </Card>
                            </div>
                        ) : null}
                    </Col>
                </Row>
            </div>
        );
    }
}
export default ViewSpecificContent;
